import React, { useState } from 'react';
import usePepe from '../../../../contexts/Pepe';
import TextField from '../../../general/controls/textField';
import fetcher, { Fetcher } from '../../../../utils/fetcher';
import localStorage from '../../../../utils/localStorage';

interface Props {
  onComplete: () => any;
}

const LoginThirdStage = ({ onComplete }: Props) => {
  const { activate } = usePepe();
  const [pass, setPass] = useState('');

  const handleLogin = () => {
    fetcher.login
      .login(pass)
      .then((result) => {
        Fetcher.setTokenHeader(result.token);
        localStorage.setToken(result.token);
        setTimeout(() => {
          onComplete();
        }, 500);
      })
      .catch(() => {
        activate();
      });
  };

  return (
    <TextField
      value={pass}
      setValue={setPass}
      onEnterPress={() => handleLogin()}
      style={{ opacity: 0 }}
      autoFocus
    />
  );
};

export default LoginThirdStage;
